import { render, staticRenderFns } from "./BrIndexContent.vue?vue&type=template&id=d03812fc&"
import script from "./BrIndexContent.vue?vue&type=script&lang=js&"
export * from "./BrIndexContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports